import React, { useEffect, useState } from "react";
import "./ProfileHeader.scss";
import { useLocation } from "react-router-dom";
import History from "../../utils/services/GlobalNavigation/navigationHistory";

const links = [
  {
    title: "Profile",
    link: "",
  },
  {
    title: "Transactions",
    link: "transactions",
  },
  {
    title: "Subscriptions",
    link: "subscriptions",
  },
  // {
  //   title: "Statistics",
  //   link: "stats",
  // },
  {
    title: "Refer & Earn",
    link: "refer",
  },
];

const ProfileHeader: React.FC = () => {
  const _location = useLocation();
  const [currentPage, setCurrentPage] = useState<string>("/");

  useEffect(() => {
    let componentMounted = true;

    if (componentMounted) {
      const lastElement = _location.pathname.split("/").pop() || "";
      setCurrentPage(lastElement === "profile" ? "" : lastElement);
      return () => {
        componentMounted = false;
      };
    }
  }, [_location]);

  return (
    <div className="ProfileHeader">
      <p>Manage Account</p>
      <ul>
        {links?.map((item, index) => (
          <li
            key={index}
            className={currentPage === item.link ? "active" : ""}
            onClick={() => {
              History.push(`/dashboard/profile/${item?.link}`);
            }}
          >
            {item?.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProfileHeader;
